import classNames from "classnames";
import { Icon } from "@zapier/zinnia-icons";
import { getUniqueAppsFromSteps, ZapMetadataStep } from "@zapier/canvas-state";
import formatAppsWithLimit from "../../utils/formatAppsWithLimit";
import { IconsList } from "./IconsList";
import styles from "./ToggleZapSteps.module.css";

type ToggleButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isExpanded: boolean;
  steps: ZapMetadataStep[];
};

export const ToggleZapSteps = ({
  onClick,
  isExpanded,
  steps,
}: ToggleButtonProps) => {
  const uniqueApps = getUniqueAppsFromSteps(steps);
  const apps = formatAppsWithLimit(uniqueApps);
  const noApps = apps.length === 0;

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.wrapperNoApps]: noApps,
      })}
    >
      {apps.length > 0 && (
        <div className={styles.iconsList}>
          <IconsList apps={apps} />
        </div>
      )}
      <button
        className={classNames(styles.toggleButton, {
          [styles.noApps]: noApps,
        })}
        onClick={onClick}
      >
        <span>{isExpanded ? "Hide" : "Show"} steps</span>
        <Icon
          name={isExpanded ? "arrowContract" : "arrowExpand"}
          size={15}
          color="TextWeaker"
        />
      </button>
    </div>
  );
};
